import {
  AccountIcon,
  ActiveLogIcon,
  FavouriteDouble,
  ReferSecondary,
} from "assets/icons";

export const linkCardItems = [
  {
    key: 1,
    label: "My Profile",
    href: "/my-profile",
    icon: AccountIcon,
  },
  {
    key: 2,
    label: "Activity log",
    href: "/activity-log",
    icon: ActiveLogIcon,
  },
  {
    key: 3,
    label: "Favorites",
    href: "/engage",
    state: { tabId: "3" },
    icon: FavouriteDouble,
  },
  {
    key: 4,
    label: "Refer & Reward",
    href: "/settings",
    state: { activeTab: "5" },
    icon: ReferSecondary,
  },
];
